import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getPosts, updatePost, deletePostData, deleteBulkPost
} from '../../ducks/post';
import {
  getUserIntegration
} from '../../ducks/reviews';
import { PostModel } from 'components';
import { IconDelete, NoDataImg, IconClose } from '../../img';
import ContentLoader from 'react-content-loader';
import { confirmAlert } from 'react-confirm-alert';
import './Post.scss';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
const moment = require('moment');
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <ContentLoader
      height={40}
      width={1060}
      speed={2}
      primaryColor="#fff"
      secondaryColor="#eceef4"
      {...props}
    >
      <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4" />
      <rect x="34" y="13" rx="6" ry="6" width={200 * random} height="12" />
      <rect x="633" y="13" rx="6" ry="6" width={23 * random} height="12" />
      <rect x="653" y="13" rx="6" ry="6" width={78 * random} height="12" />
      <rect x="755" y="13" rx="6" ry="6" width={117 * random} height="12" />
      <rect x="938" y="13" rx="6" ry="6" width={83 * random} height="12" />
      <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3" />
    </ContentLoader>
  );
};

let searchQRY = {};
class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pgNum: 1,
      isLoading: false,
      hasMore: false,
      pagingCount: 0,
      ocPost: false,
      fn: '',
      ln: '',
      un: '',
      rtng: '',
      msg: '',
      _id: '',
      allSel: false,
      delArry: [],
      noOfRecord: 0,
      tabIndex: 0,
      isLoadMore: false,
      searchPostText: '',
      searchReviewText: '',
      isDisabledTextBox: false,
      startDate: '',//Picker start date
      endDate: '',//Picker end date,
      chipsData: '',//Selected data source value in chips
      postHashTag: ''
    };
  }

  componentDidMount() {
    searchQRY = {
      pageNo: this.state.pgNum,
      today: {
        from: new Date().setHours(0, 0, 0, 0),
        to: new Date().setHours(24, 0, 0, 0)
      }
    };
    this.props.getPosts(searchQRY);
    this.props.getUserIntegration({ type: 'feed' });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.postData !== this.props.postData && this.props.postData !== this.state.items) {
      let { postData } = this.props;
      //page number one then store data count in the state
      if (postData && postData.count) {
        this.state.noOfRecord = postData.count;
        this.setState(this.state);
      }
      if (postData && postData.data && postData.data.length === 0) {
        this.state.hasMore = false;
        this.state.isLoading = false;
        this.setState(this.state);
      }
      else if (postData && postData.data && postData.data.length > 0) {
        if (postData.data.length < 10) {
          this.state.items = [...this.state.items, ...postData.data];
          this.state.hasMore = false;
        }
        else {
          this.state.pagingCount = this.state.pagingCount + 10;
          this.state.items = [...this.state.items, ...postData.data];
          this.state.hasMore = true;
        }
      }
      this.state.isDisabledTextBox = false;
      this.state.isLoading = false;
      this.setState(this.state);
    }
  }

  removeData = () => {
    this.state.hasMore = true;
    this.state.items = [];
    this.setState(this.state);
  }

  //get
  //get post with paging
  getPostsPG = (tabIndex, pageNo) => {
    this.state.pgNum = pageNo;
    this.state.tabIndex = tabIndex;
    this.state.isLoadMore = true;
    this.state.startDate = '';
    this.state.endDate = '';
    this.setState(this.state);
    let fromApp = searchQRY['fa'];
    //today data search query
    if (tabIndex == 0) {
      searchQRY = {};
      searchQRY = {
        pageNo: this.state.pgNum,
        fa: fromApp,
        searchPostText: this.state.searchPostText ? this.state.searchPostText : '',
        today: {
          from: new Date().setHours(0, 0, 0, 0),
          to: new Date().setHours(24, 0, 0, 0)
        }
      };
    }
    //all data search query
    else if (tabIndex == 1) {
      searchQRY = {};
      searchQRY = {
        pageNo: this.state.pgNum,
        fa: fromApp,
        searchPostText: this.state.searchPostText ? this.state.searchPostText : ''
      };
    }
    //change tab then old data remove and start to form the beginning
    if (pageNo === 1) {
      this.state.pagingCount = 0;
      this.state.isLoading = true;
      this.setState(this.state);
      this.removeData();
    }
    this.props.getPosts(searchQRY);
  }

  //create 
  //add new hash tag
  addHtg = (e) => {
    let code = e.keyCode || e.which;
    if (code == 13) {
      let chkDuplicate = this.state.postHashTag.filter(x => x == this.state.uphtg);
      if (chkDuplicate.length == 0) {
        this.state.postHashTag.push(this.state.uphtg);
        this.setState(this.state);
      }
      else {
        toast.error('Hash tag already added');
      }
    }
  }

  //update 
  //update post
  updatePost = (obj) => {
    let { msg, htg } = this.state;
    this.props.updatePost({ _id: obj, msg: msg, htg: htg });
  }

  //delete
  //handleSelectAll for delete
  handleSelectAll = (target) => {
    if (this.state.items.length > 0) {
      if (target == true) {
        for (let i = 0; i < this.state.items.length; i++) {
          const s = this.state.items[i];
          let _index = this.state.delArry.findIndex(x => x._id == s._id);
          if (_index == -1) {
            this.state.delArry.push({ _id: s._id, ia: target });
            this.setState(this.state);
          }
        }
      }
      else {
        this.state.delArry = [];
      }
      this.state.allSel = target;
      this.setState(this.state);
    }
  }

  //select multiple data to delete
  deleteMulti = (_id, target) => {
    let _index = this.state.delArry.findIndex(x => x._id == _id);
    if (_index == -1) {
      this.state.delArry.push({ _id: _id, ia: target });
    }
    else {
      var index = _index;
      var array = this.state.delArry;
      if (index > -1) {
        array.splice(index, 1);
      }
      this.state.delArry = array;
      this.setState(this.state);
    }
    if (this.state.delArry.length == this.state.items.length) {
      this.state.allSel = true;
    }
    else {
      this.state.allSel = false;
    }
    this.setState(this.state);
  }

  //delete single post data
  deletePostData = (id) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirm to Delete</h1>
            <p>Are you sure to do this.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => {
                this.state.items = []; this.state.isLod = false; this.state.co = 0;
                this.state.pgNum = 1; this.state.hasMore = false; this.setState(this.state);
                this.props.deletePostData(id), onClose();
              }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              Cancel
            </button>
          </div>
        );
      }
    });
  }

  //delete bluk post data
  deleteBulk = () => {
    let obj = { array: this.state.delArry };
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirm to Delete</h1>
            <p>Are you sure to do this.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => {
                this.state.items = []; this.state.isLod = false; this.state.co = 0; this.state.delArry = []; this.state.allSel = false;
                this.state.pgNum = 1; this.state.hasMore = false; this.setState(this.state);
                this.props.deleteBulkPost(obj), onClose();
              }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              Cancel
            </button>
          </div>
        );
      }
    });
  }

  //others
  //initialize state
  init = () => {
    this.setState({
      items: [],
      pgNum: 1,
      isLoading: false,
      hasMore: false,
      pagingCount: 0,
      ocReview: false,
      fn: '',
      ln: '',
      un: '',
      rtng: '',
      msg: '',
      _id: '',
      allSel: false,
      delArry: [],
      noOfRecord: 0,
      tabIndex: 0,
      isLoadMore: false,
      searchPostText: '',
      searchReviewText: '',
      isDisabledTextBox: false,
      startDate: '',//Picker start date
      endDate: '',//Picker end date,
      chipsData: '',//Selected data source value in chips
      postHashTag: ''
    });
  }

  //close post model
  closeModal = () => { this.init(); }

  //open post model
  opPostModel = (obj) => {
    this.state = obj;
    this.state.ocPost = true;
    this.setState(this.state);
  }

  //remove chips for hash tag
  removeArrChips = (key) => {
    let index = key, array = this.state.postHashTag;
    if (index > -1) { array.splice(index, 1); }
    this.state.postHashTag = array;
    this.setState(this.state);
  }

  //render post div
  renderPosts = () => {
    let { items, allSel } = this.state;
    return <div>
      <div className="visitor-data-content table-responsive">
        <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
          <thead className="thead-light">
            <tr>
              <th> <div className="table-userdata-checkboc">
                <div className="secstyle-checkbox  userdata-icon-checkboc" style={{ top: '-4px', left: '-5px' }}>
                  <label><input type="checkbox" checked={allSel} onChange={(e) => this.handleSelectAll(e.target.checked)} /></label>
                </div>
              </div></th>
              <th className="tbl-no-col">No.</th>
              <th className="text-nowrap">Message</th>
              <th className="text-nowrap">Hash Tag</th>
              <th className="text-nowrap">Source</th>
              <th className="text-nowrap">Date</th>
              <th className="text-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.isLoading == true ?
              <tr>
                <td colSpan="8">
                  {Array(8)
                    .fill('')
                    .map((e, i) => (
                      <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                    ))}
                </td>
              </tr> :
              items && items.length > 0 ?
                items.map((obj, i) => {
                  let { fa, insdt, msg, htg, _id } = obj;
                  if (_id == this.state._id) {
                    obj.msg = this.state.msg;
                  }
                  let mulSelect = false;
                  if (this.state.delArry.length > 0) {
                    for (let i = 0; i < this.state.delArry.length; i++) {
                      const d = this.state.delArry[i];
                      if (obj._id == d._id) {
                        mulSelect = true;
                      }
                    }
                  }
                  return (
                    <tr key={i + 1}>
                      <td>
                        <div className="table-userdata-checkboc">
                          <div className="secstyle-checkbox  userdata-icon-checkboc" style={{ top: '-4px', left: '-5px' }}>
                            <label><input type="checkbox" checked={mulSelect} onChange={(e) => this.deleteMulti(obj._id, e.target.checked)} /></label>
                          </div>
                        </div>
                      </td>
                      <td>{i + 1}</td>
                      <td className="td-15x">{msg ? msg : '-'}</td>
                      <td>{htg.length > 0 ? htg.join(', ') : '-'}</td>
                      <td>{fa}</td>
                      <td>{days_between(insdt)}</td>
                      <td>
                        <div className="signup-data-action">
                          {/* <button className="nf-btn btn-edit" onClick={() => this.opPostModel(obj)}>Edit</button> */}
                          <span className="nf-btn  btn-delete-light  light-bg-icon btn-icon-30" onClick={() => this.deletePostData(obj._id)}><img src={IconDelete} alt="" /></span>
                        </div>
                      </td>
                    </tr>
                  );
                })
                :
                <tr>
                  <td colSpan="11" className="text-center">
                    <div className="clearfix"></div>
                    <div className="nodata-block">
                      <div className="nodata-box">
                        <img src={NoDataImg} alt="No data" />
                        <h4>Looks like there isn't any post data to show yet.</h4>
                      </div>
                    </div>
                  </td>
                </tr>
            }
            {this.state.hasMore == true && this.state.isLoading == false &&
              <tr>
                <td colSpan="8" style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.getPostsPG(this.state.tabIndex, this.state.pgNum + 1)}>
                  {this.state.pagingCount} record displayed out of {this.state.noOfRecord} records
                  <a className="text-primary" style={{ textDecoration: 'none' }}> Load more</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>;
  }

  //handle state change
  hanStateChg = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleEventForSearchByDate = (event, pickerDate) => {
    if (event.handleObj.type == 'apply') {
      if (new Date(pickerDate.startDate) && new Date(pickerDate.endDate)) {
        this.state.startDate = new Date(pickerDate.startDate);
        this.state.endDate = new Date(pickerDate.endDate);
        this.state.items = [];
        this.state.pagingCount = 0;
        this.state.noOfRecord = 0;
        this.state.tabIndex = 2;
        let fromApp = searchQRY['fa'];
        this.state.isDisabledTextBox = true;
        searchQRY = {};
        searchQRY = {
          pageNo: 1,
          fa: fromApp,
          searchPostText: this.state.searchPostText ? this.state.searchPostText : '',
          custom: {
            from: this.state.startDate ? this.state.startDate : '',
            to: this.state.endDate ? this.state.endDate : ''
          }
        };
        this.setState(this.state);
        this.props.getPosts(searchQRY);
      }
    }
  }

  renderDate = () => {
    if (this.state.startDate && this.state.endDate) {
      return <DateRangePicker
        onEvent={this.handleEventForSearchByDate}
        maxDate={moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('MM-DD-YYYY')}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
      >
        Custom Date</DateRangePicker>;
    }
    else {
      return <DateRangePicker
        onEvent={this.handleEventForSearchByDate}
        maxDate={moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('MM-DD-YYYY')}
      >Custom Date</DateRangePicker>;
    }
  }

  //search post
  searchPost = (e) => {
    let code = e.keyCode || e.which;
    if (code == 13) {
      this.state.isDisabledTextBox = true;
      this.getPostsPG(this.state.tabIndex, 1);
      this.setState(this.state);
    }
  }

  //handle state change
  handleStateChange = (e) => {
    if (e.target.name == 'searchPostText' && !e.target.value) {
      this.state.items = [];
      this.state.searchPostText = '';
      this.state.isDisabledTextBox = true;
      this.setState(this.state);
      this.getPostsPG(this.state.tabIndex, 1);
    }
    else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  getSelectedDataSource = (chipsArr) => {
    let arrFuid = [];
    this.state.items = [];
    this.state.isDisabledTextBox = true;
    this.state.pagingCount = 0;
    this.state.noOfRecord = 0;
    searchQRY = {};
    searchQRY = {
      pageNo: 1,
      searchPostText: this.state.searchPostText ? this.state.searchPostText : '',
      custom: {
        from: this.state.startDate ? this.state.startDate : '',
        to: this.state.endDate ? this.state.endDate : ''
      }
    };
    searchQRY['today'] = {};
    searchQRY['custom'] = {};
    if (this.state.tabIndex == 0) {
      searchQRY['today'] = {
        from: new Date().setHours(0, 0, 0, 0),
        to: new Date().setHours(24, 0, 0, 0)
      };
    }
    else if (this.state.tabIndex == 2) {
      searchQRY['custom'] = {
        from: this.state.startDate ? this.state.startDate : '',
        to: this.state.endDate ? this.state.endDate : ''
      };
    }
    if (chipsArr && chipsArr.length > 0) {
      this.setState({ chipsData: chipsArr });
      for (let i = 0; i < chipsArr.length; i++) {
        arrFuid.push({ fuid: chipsArr[i].value });
      }
      searchQRY['fa'] = arrFuid;
    }
    else {
      this.state.chipsData = '';
      searchQRY['fa'] = '';
    }
    this.setState(this.state);
    this.props.getPosts(searchQRY);
  }

  render() {
    let dataSourceOption = [];
    if (this.props.userIntegration && this.props.userIntegration.length > 0) {
      this.props.userIntegration.map((userInt) => {
        let intName = userInt.inm;
        if (userInt.rmk) {
          intName = userInt.inm + ' | ' + userInt.rmk;
        }
        dataSourceOption.push({
          label: intName,
          value: userInt._id
        });
      });
    }
    return (
      <div className="main-container visitor-container" >
        <div className="visitor-content">
          <div className="">
            <div className="page-content-topbar analytic-topbar visitor-topbar">
              <div className="topbar-left">
                <div className="tab-same tab-analytic-block">
                  <ul className="tab-same-list tab-analytic-list">
                    <li className={this.state.tabIndex === 0 ? 'active' : ''} onClick={() => this.getPostsPG(0, 1)}>Today</li>
                    <li className={this.state.tabIndex === 1 ? 'active' : ''} onClick={() => this.getPostsPG(1, 1)}>All Post</li>
                    <li className={this.state.tabIndex === 2 ? 'active' : ''}>
                      {this.renderDate()}
                    </li>
                    <input type="text"
                      className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-mainvisitor"
                      name="searchPostText"
                      placeholder="Search by Post text"
                      onKeyPress={(e) => this.searchPost(e)}
                      onChange={(e) => this.handleStateChange(e)}
                      disabled={this.state.isDisabledTextBox} />
                  </ul>
                </div>
              </div>
            </div>
            <div className="clearfix"></div>
            <div className="integration-chips-siupdata integration-chips integration-select-chips">
              <div className="integration-data-select">
                {this.props.userIntegration && this.props.userIntegration.length > 0 &&
                  <ReactMultiSelectCheckboxes
                    options={dataSourceOption}
                    onChange={this.getSelectedDataSource}
                    placeholderButtonLabel='Select data source'
                  />
                }
              </div>
              <div className="chips-block">
                {this.state.chipsData && this.state.chipsData.length > 0 ?
                  <ul className="chips-list">
                    {this.state.chipsData.map((l, i) => {
                      return (
                        <li key={i}>{l.label} <i onClick={() => this.removeSelectedDataSource(i)}><img src={IconClose} /></i></li>
                      );
                    })}
                  </ul>
                  : ''}
              </div>
            </div>
            <div>
              <div className="analytic-data-content">
                {
                  this.state.delArry.length > 0 &&
                  <div className="top-delete-option">
                    <button className="nf-btn btn-delete-all" onClick={() => this.deleteBulk()}>
                      Delete All
                    </button>
                    {/* <span className="nf-btn  btn-delete-light  light-bg-icon btn-icon-30"><img src={IconDelete} alt="" /></span> */}
                  </div>
                }
                {this.renderPosts()}
              </div>
            </div>
            {this.state.ocPost == true &&
              <PostModel
                data={this.state}
                closeModal={this.closeModal}
                hanStateChg={this.hanStateChg}
                updatePost={this.updatePost}
                removeArrChips={this.removeArrChips}
                addHtg={this.addHtg}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

const days_between = (date) => {
  if (new Date() >= new Date(date)) {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) { return interval + ' years ago'; }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) { return interval + ' months ago'; }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) { return interval + ' days ago'; }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) { return interval + ' hours ago'; }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) { return interval + ' minutes ago'; }
    return Math.floor(seconds) + ' seconds ago';
  }
  else { return 'live'; }
};

const mapStateToProps = state => ({
  postData: state.getIn(['post', 'postData']),
  userIntegration: state.getIn(['reviews', 'userIntegration'])
});

const mapDispatchToProps = {
  getPosts,
  updatePost,
  getUserIntegration,
  deletePostData,
  deleteBulkPost
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Post);


// WEBPACK FOOTER //
// ./src/containers/Post/Post.js